module.exports = __webpack_public_path__ + "static/media/mixkit-achievement-bell-600.14a5bc11.wav";